import {func} from 'prop-types'
import Attribute from './Attribute'

const VmViewAttribute = {
  ...Attribute,
  ref: func || undefined,
}

export default VmViewAttribute
